import React from "react";
import { Link } from "react-router-dom";
import { Calendar, MessageCircle, ShieldCheck } from "lucide-react";
import { Reveal } from "./Section";

const PORTRAIT = "/images/courtier-assurance-aurillac-cantal-pas-cher.webp";

/**
 * InterlocuteurSection — carte courtier sobre, sans widget Calendly inline.
 * Le widget Calendly est désormais affiché UNIQUEMENT dans la section
 * "Prendre rendez-vous" (footer + page /rendez-vous) pour éviter les doublons.
 */
export default function InterlocuteurSection() {
  return (
    <section
      id="interlocuteur"
      data-testid="interlocuteur-section"
      className="relative py-24 md:py-32 bg-brand-sand-2"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <Reveal>
          <div className="bg-white rounded-3xl border border-brand-border p-10 md:p-16 grid md:grid-cols-[auto_1fr] gap-10 md:gap-14 items-center">
            <div className="h-28 w-28 md:h-36 md:w-36 rounded-full overflow-hidden border border-brand-border bg-brand-sand-2 shrink-0 mx-auto md:mx-0">
              <img
                data-testid="nassim-photo"
                src={PORTRAIT}
                alt="Nassim Aali — courtier indépendant Aurillac Cantal"
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover object-top"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
            </div>

            <div className="text-center md:text-left">
              <div className="overline">Votre interlocuteur dédié</div>
              <div className="mt-4 font-serif text-3xl md:text-4xl tracking-tight">
                Nassim Aali
              </div>
              <div className="text-xs tracking-[0.2em] uppercase text-brand-ink/65 mt-2 font-semibold inline-flex items-center gap-2">
                <ShieldCheck className="h-3.5 w-3.5" />
                Courtier indépendant · ORIAS n°&nbsp;26008264
              </div>

              <p className="mt-8 font-editorial italic text-xl md:text-[24px] leading-snug text-brand-ink max-w-xl">
                "Chaque client est unique. Je m'engage personnellement à trouver
                la meilleure solution pour vous."
              </p>

              <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center md:justify-start">
                <Link
                  data-testid="interloc-calendly-cta"
                  to="/rendez-vous"
                  className="btn-press inline-flex items-center justify-center gap-2 rounded-full bg-brand-ink hover:bg-black text-white px-7 py-4 text-[12px] font-semibold tracking-[0.2em] uppercase"
                >
                  <Calendar className="h-4 w-4" /> Prendre rendez-vous
                </Link>
                <a
                  data-testid="interloc-whatsapp-cta"
                  href="https://wa.me/33615907316"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-press inline-flex items-center justify-center gap-2 rounded-full bg-white border border-brand-ink text-brand-ink hover:bg-brand-ink hover:text-white px-7 py-4 text-[12px] font-semibold tracking-[0.2em] uppercase transition-colors"
                >
                  <MessageCircle className="h-4 w-4" /> Écrire sur WhatsApp
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
